import { getIssueTypes, getAllItemTypes } from 'src/services/client';
import { useEffect, useState } from 'react';

interface UseFormOptionsReturn {
  servicesProvidedTypes: any[];
  allItemTypes: any[];
  isLoading: boolean;
  error: string | null;
  refetchSPTypes: () => Promise<void>;
  refetchItemTypes: () => Promise<void>;
}

export const useFetchServicesProvidedTypes = (): UseFormOptionsReturn => {
  const [servicesProvidedTypes, setServicesProvidedTypes] = useState<any[]>([]);
  const [allItemTypes, setAllItemTypes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchIssueTypes = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const response: any = await getIssueTypes();

      if (response.ok || response.status === 200) {
        const data = await response.json();
        setServicesProvidedTypes(data);
      } else {
        setError('Failed to fetch issue types');
      }
    } catch (err) {
      console.error('Error fetching issue types:', err);
      setError('An error occurred while fetching issue types');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllItemTypes = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const response: any = await getAllItemTypes();

      if (response.ok || response.status === 200) {
        const data = await response.json();

        const mappedItemTypes: any = data.map((item: any) => ({
          value: item.id,
          label: item.name,
        }));

        setAllItemTypes(mappedItemTypes);
      } else {
        setError('Failed to fetch item types');
      }
    } catch (err) {
      console.error('Error fetching item types:', err);
      setError('An error occurred while fetching item types');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchIssueTypes();
    fetchAllItemTypes();
  }, []);

  return {
    servicesProvidedTypes,
    allItemTypes,
    isLoading,
    error,
    refetchSPTypes: fetchIssueTypes,
    refetchItemTypes: fetchAllItemTypes,
  };
};
